module.exports = "<div class=\"card\">\n  <div class=\"card-content\">\n    <h1>{{ 'DAILY_QUOTA_LIMIT' | translate }}</h1>\n    <i *ngIf=\"isAdmin\" class=\"icon fas fa-pen\" (click)=\"openDialog()\"></i>\n    <hr>\n    <div class=\"row\">\n      <label *ngIf=\"ownQuota !== undefined\" class=\"own-quota\">{{ ownQuota | number }}</label>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/components/myaccount/components/quota-info/quota-info.component.html
// module id = 1409
// module chunks = 0